import { module } from "angular";
import {
    TimeFilters,
    FromNow,
    IsInFuture,
    LocalizeHoursNumber,
    OrderDaysByLocale,
    TranslateIsoWeekday,
} from "./TimeFilters";

module("mmGui")
    .filter("mmDurationToLocalTimeString", () => TimeFilters.durationToLocalTimeString) // eslint-disable-line @typescript-eslint/unbound-method
    .filter("irFromNow", FromNow)
    .filter("irIsInFuture", IsInFuture)
    .filter("irLocalizeHoursNumber", LocalizeHoursNumber)
    .filter("irOrderDaysByLocale", OrderDaysByLocale)
    .filter("irTranslateIsoWeekday", TranslateIsoWeekday);
